import type { Colors } from '../constants';

const colors = [
  'bg-ds-secondary-400',
  'bg-ds-secondary-500',
  'bg-ds-accent2-400',
  'bg-ds-accent1-300',
  'bg-ds-primary-200',
  'bg-ds-primary-400',
  'bg-ds-danger-200',
];

export const stringToColor = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 4) - hash);
  }
  return colors[Math.abs(hash % 7)] as Colors;
};
